import { render } from "./UserInput.vue?vue&type=template&id=27f94863&scoped=true"
import script from "./UserInput.vue?vue&type=script&lang=js"
export * from "./UserInput.vue?vue&type=script&lang=js"

import "./UserInput.vue?vue&type=style&index=0&id=27f94863&scoped=true&lang=css"

import exportComponent from "D:\\Build Apps\\Natan\\jlm_manager\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27f94863"]])

export default __exports__